import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Dropdown from "components/forms/inputs/dropdown";
import { OptionInterface } from "components/forms/inputs/dropdown.styles";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { faUserShield } from "components/icon-library";
import Info from "components/info";
import { Admin } from "models/admin";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";

interface AccessFormProps {
  admin: Admin;
  onSubmit: (values: any) => Promise<void>;
  onClose: () => Promise<void>;
}

type ACCESS = "ORG_ADMIN" | "ADMIN" | "NOTHING";

const AccessForm: FunctionComponent<AccessFormProps> = ({
  admin,
  onSubmit,
  onClose,
}) => {
  const schema = yup
    .object({
      access: yup.string(),
    })
    .required();

  const getDefault = (): ACCESS => {
    if (admin.active === false) {
      return "NOTHING";
    } else if (admin.org_admin) {
      return "ORG_ADMIN";
    } else {
      return "ADMIN";
    }
  };

  const methods = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      access: getDefault(),
    },
  });

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton, text: "Vaihda", postIcon: faUserShield },
  ];

  const accessOptions: OptionInterface[] = [
    {
      value: "ORG_ADMIN",
      text: "Luettelot ja asetukset.",
    },
    {
      value: "ADMIN",
      text: "Luettelot.",
    },
    {
      value: "NOTHING",
      text: "Ei pääsyä.",
    },
  ];

  const { access } = methods.getValues();
  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <Grid>
        <Row>
          <Col>
            <Dropdown
              label="Pääsyoikeustaso"
              name="access"
              options={accessOptions}
            />
          </Col>
        </Row>
        <Row>
          {access === "ORG_ADMIN" && (
            <Info>
              Ylläpitäjällä on pääsy organisaation asetuksiin ja niihin
              luetteloihin, joihin hänelle on erikseen annettu pääsyoikeus.
            </Info>
          )}
          {access === "ADMIN" && (
            <Info>
              Ylläpitäjällä on pääsy niihin luetteloihin, joihin hänelle on
              erikseen annettu pääsyoikeus.
            </Info>
          )}
          {access === "NOTHING" && (
            <Info>
              Ylläpitäjällä ei ole pääsyä mihinkään toimintoon eikä ylläpitäjä
              voi kirjautua omilla tunnuksillaan.
            </Info>
          )}
        </Row>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default AccessForm;
